<template>
  <div>
    <b-overlay :show="showSpinner" rounded="sm">
      <b-card title="Completed Delivery Module">
        <b-row>
          <b-col cols="6">
          </b-col>
          <b-col cols="6">
            <div class="position-relative">
              <b-form-input
                v-model="search"
                @input="debounceSearch"
                type="text"
                placeholder="Cari Picklist"
              />
              <b-spinner
                v-if="showSpinner"
                small
                variant="primary"
                class="position-absolute"
                style="right: 10px; top: 10px;"
              />
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col cols="12">
            <b-table
              hover
              responsive
              head-variant="dark"
              small
              outlined
              :items="filteredItems"
              :fields="headers"
              :per-page="perPage"
              :current-page="currentPage"
              show-empty
            >
              <template v-slot:cell(listPicklist)="row">
                {{row.item.item.map((x) => 
                  `${x.pickList.picklistNo}_${x.pickList.picklistLine}`
                ).join(', ')}}
              </template>
              <template v-slot:cell(listOrderNumber)="row">
                {{ formatJoin(row.item.listOrderNumber)}}
              </template>
              <template v-slot:cell(actions)="row">
                <b-button
                  variant="primary"
                  size="sm"
                  :to="{ name: 'view-detail-delivery', params: { id: row.item.id } }"
                  style="margin-right: 10px;">
                  View
                </b-button>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="4" class="pt-1">
            <b-form-group
              label="Data Per Page"
              label-for="per-page-select"
              label-cols-md="0"
              label-align-sm="left"
              label-size="md"
              class="mb-0"
            >
              <v-select
                class="select-sm"
                :clearable="false"
                id="per-page-select"
                v-model="perPage"
                :options="pageOptions"
                size="sm"
                @input="fetchDeliveries"
              ></v-select>
            </b-form-group>
          </b-col>
          <b-col class="pt-1">
            <b-pagination
              v-model="currentPage"
              :per-page="perPage"
              @change="onPageChange"
              :total-rows="totalRows"
              first-number
              last-number
              class="float-right"
              aria-controls="delivery-table"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showSpinner: false,
      search: "",
      status: "Created",
      headers: [
        { key: 'deliveryNumber', label: 'Delivey Number', sortable: false },
        { key: 'listOrderNumber', label: 'List SO Number', sortable: true },
        { key: 'listPicklist', label: 'List Picklist', sortable: true },
        { key: 'status', label: 'Status', sortable: false },
        { key: 'actions', label: 'Actions'}
      ],
      filteredItems: [],
      perPage: 10,
      pageOptions: [5, 10, 20, 50],
      currentPage: 1,
      totalRows: 0,
      debounce: null
    }
  },
  computed: {
  },
  methods: {
    formatJoin(data) {
      if (!Array.isArray(data) || data.length === 0) {
        return ''
      }
      // Remove empty strings and undefined, then deduplicate
      const filtered = Array.from(new Set(data.filter(x => x !== '' && x !== undefined && x !== ' ')))
      return filtered.join(', ')
    },
    debounceSearch() {
      this.showSpinner = true;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.showSpinner = false;
        this.fetchDeliveries();
      }, 400);
    },
    filterItems() {
      this.fetchDeliveries();
    },
    fetchDeliveries() {
      this.showSpinner = true;
      const params = {
        search: this.search,
        page: this.currentPage,
        limit: this.perPage,
        status: 'Completed'
      };
      this.$store.dispatch('delivery/getDeliveries', params)
        .then(pagination => {
          this.filteredItems = this.$store.getters['delivery/getDeliveryOrder'];
          this.totalRows = pagination ? pagination.totalData : 0;
          this.showSpinner = false;
        })
        .catch(() => {
          this.showSpinner = false;
        });
    },
    onPageChange(page) {
      this.currentPage = page;
      this.fetchDeliveries();
    }
  },
  mounted() {
    this.fetchDeliveries();
  }
}
</script>

<style>
.select-sm .vs__dropdown-toggle {
  min-height: 30px;
}
</style>